<template>
  <div>
    <h1>Admin Login</h1>
    <p class="widget-auth-info">
      {{ $t("useYourEmailToLogin") }}
    </p>
    <login-form redirect-route="admindashboard" />

    <router-link :to="{ name: 'partnerlogin' }" class="mr-2">
      <b-button variant="outline-dark">{{ $tc("partner") }}</b-button>
    </router-link>

    <router-link :to="{ name: 'login' }">
      <b-button variant="outline-dark">{{ $tc("user") }}</b-button>
    </router-link>
  </div>
</template>

<script>
// @ is an alias to /src
import LoginForm from "@/components/LoginForm.vue";

export default {
  name: "LoginAdminView",
  components: {
    LoginForm
  }
};
</script>

<style scoped lang="scss"></style>
